package devxertech.com.pages.commons

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextTransform
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.letterSpacing
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.component.FieldTitleTextNormalSimple
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Constants
import kotlinx.browser.window
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnit
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.whiteSpace

@Composable
fun TeamService(
    image: String, title: String,
    description: String,
    bullet: Boolean = false,
    modifier: Modifier = Modifier,
    titleFontSize: CSSSizeValue<CSSUnit.px>? = null,
) {

    val breakpoint = rememberBreakpoint()
    val sitePalette = ColorMode.current.toSitePalette()

    Box(modifier = Modifier.position(Position.Relative)) {
        Box(
            modifier = Modifier
                .width(if (breakpoint == Breakpoint.MD || breakpoint <= Breakpoint.SM) 120.px else 198.px)
                .height(251.px)
                .backgroundColor(sitePalette.primary.rgb)
                .position(Position.Absolute)
                .left(if (breakpoint > Breakpoint.MD) 217.px else if (breakpoint == Breakpoint.MD) 202.px else 199.px)
                .top(28.px)
                .zIndex(1)
        )
        Box(
            modifier = Modifier
                .width((if (breakpoint > Breakpoint.MD) 320.px else if (window.screen.width in 952..1350) 321.px else if (breakpoint == Breakpoint.MD || breakpoint <= Breakpoint.SM) 240.px else 312.px))
                .height(312.px)
                .margin(
                    leftRight = if (breakpoint > Breakpoint.MD) 80.px else 70.px,
                    topBottom = 40.px
                )
                .backgroundColor(sitePalette.bodyBackgroundSecondary.rgb)
                .borderRadius(14.px)
                .zIndex(2)
                .boxShadow(blurRadius = 49.px, spreadRadius = (-9).px, color = Colors.LightGray),
            contentAlignment = Alignment.TopCenter
        ) {
            Column(
                modifier = modifier.then(Modifier.fillMaxWidth()),
                verticalArrangement = Arrangement.Top,
                horizontalAlignment = Alignment.CenterHorizontally,
            ) {
                Row(
                    modifier = Modifier.fillMaxWidth().margin(bottom = 10.px),
                    horizontalArrangement = Arrangement.Center
                ) {
                    FieldTitleTextNormalSimple(
                        text = title,
                        color = sitePalette.commonSecondaryButtonColor.rgb,
                        fontFamily = Constants.ROBOTO_FONT,
                        fontSize = titleFontSize
                            ?: if (breakpoint == Breakpoint.MD) 15.px else 17.px,
                        textAlign = TextAlign.Center,
                        fontWeight = 600,
                        textTransform = TextTransform.Uppercase,
                        whiteSpace = if (breakpoint < Breakpoint.MD) WhiteSpace.Normal else WhiteSpace.PreWrap,
                        marginTop = 50.px,
                        letterSpacing = 0.5.px
                    )

                }
                if (bullet) {
                    description.split("\n").forEach { line ->
                        Row(
                            verticalAlignment = Alignment.Top,
                            modifier = Modifier.fillMaxWidth()
                                .padding(leftRight = if (breakpoint <= Breakpoint.MD) 25.px else 40.px)
                        ) {
                            SpanText(
                                text = "•", modifier = Modifier
                                    .fontFamily(Constants.FONT_FAMILY)
                                    .fontSize(14.px)
                                    .color(sitePalette.commonSecondaryButtonColor.rgb)
                                    .fontWeight(FontWeight.Bold)
                                    .margin(
                                        right = 8.px,
                                        top = if (breakpoint > Breakpoint.MD) 3.px else 0.px
                                    )
                            )
                            SpanText(text = line, modifier = Modifier
                                .fontFamily(Constants.FONT_FAMILY)
                                .fontSize(14.px)
                                .color(sitePalette.commonSecondaryButtonColor.rgb)
                                .fontWeight(FontWeight.Normal)
                                .lineHeight(if (breakpoint > Breakpoint.MD) 23.px else 18.px)
                                .letterSpacing(if (breakpoint == Breakpoint.MD) 0.px else 0.px)
                                .textAlign(TextAlign.Left)
                                .styleModifier { whiteSpace("pre-wrap") }
                            )
                        }
                    }
                } else {
                    Row(
                        modifier = Modifier.fillMaxWidth().padding(leftRight = if (breakpoint <= Breakpoint.MD) 25.px else 40.px),
                        horizontalArrangement = Arrangement.Center,
                        verticalAlignment = Alignment.Top,
                    ) {
                        SpanText(
                            text = description,
                            modifier = Modifier
                                .fontFamily(Constants.FONT_FAMILY)
                                .lineHeight(if (breakpoint > Breakpoint.MD) 22.px else 17.px)
                                .fontSize(if (breakpoint <= Breakpoint.MD) 13.px else 14.px)
                                .color(sitePalette.commonSecondaryButtonColor.rgb)
                                .textAlign(TextAlign.Center)
                                .whiteSpace(WhiteSpace.PreWrap)
                        )
                    }
                }
            }
        }

        Image(src = image, modifier = Modifier
            .width(if (breakpoint == Breakpoint.MD) 70.px else 93.px)
            .height(80.px)
            .position(Position.Absolute)
            .left(if (breakpoint > Breakpoint.MD) 16.px else if (breakpoint == Breakpoint.MD) 22.px else 8.px)
            .top(50.percent)
            .transform { translateY((-50).percent) }
            .zIndex(3)
        )
    }
}